var _defs, _rect, _ellipse, _ellipse2, _ellipse3, _line, _circle, _path, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path4, _rect2, _rect3, _rect4, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTitaton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: 120,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "body",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F89A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA7637"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gold",
    cx: "40%",
    cy: "35%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F6D689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#E6B24A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C9942F"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 28,
    fill: "#FFF6EE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 104,
    rx: 22,
    ry: 4,
    fill: "#C9A98E",
    opacity: 0.18
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49,
    cy: 98,
    rx: 8,
    ry: 5.5,
    fill: "#E06F37"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71,
    cy: 98,
    rx: 8,
    ry: 5.5,
    fill: "#E06F37"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 24,
    x2: 60,
    y2: 14,
    stroke: "#EA7637",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 11,
    r: 3.5,
    fill: "#3D7BC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 22c26 0 40 18 40 46 0 30-17 50-40 50S20 98 20 68c0-28 14-46 40-46Z",
    fill: "url(#body)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 44c-6-8-5-18 2-19 6-1 10 7 8 16Z",
    fill: "#EA7637"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92 44c6-8 5-18-2-19-6-1-10 7-8 16Z",
    fill: "#EA7637"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 62,
    r: 7,
    fill: "#FBB089",
    opacity: 0.65
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 62,
    r: 7,
    fill: "#FBB089",
    opacity: 0.65
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 54,
    r: 6.5,
    fill: "#2E2A5E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 54,
    r: 6.5,
    fill: "#2E2A5E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 52,
    r: 2.2,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 52,
    r: 2.2,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66 Q60 76 68 66",
    stroke: "#2E2A5E",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 86,
    width: 30,
    height: 12,
    rx: 3,
    fill: "url(#gold)",
    stroke: "#7A5A2E",
    strokeWidth: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 86,
    width: 30,
    height: 4,
    rx: 2,
    fill: "#D9A441",
    stroke: "#7A5A2E",
    strokeWidth: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 86,
    width: 6,
    height: 8,
    rx: 1.2,
    fill: "#FBE3A0",
    stroke: "#7A5A2E",
    strokeWidth: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 90,
    r: 1,
    fill: "#7A5A2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTitaton);
export default __webpack_public_path__ + "static/media/logo-titaton.6ca8ca3dd275f2f172f295822405eef4.svg";
export { ForwardRef as ReactComponent };